import React from 'react';
import PropTypes from 'prop-types';
import ListView from '../views/ListView';

const DashboardView = ({
  events,
  Component,
  handleSelectEvent,
  handleChangeStatusClick,
  restricted,
  ...props
}) => (
  <Component
    className="dashboard-view-container"
    events={events}
    handleSelectEvent={handleSelectEvent}
    handleChangeStatusClick={handleChangeStatusClick}
    restricted={restricted}
    {...props}
  />
);

DashboardView.propTypes = {
  events: PropTypes.array,
  Component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  handleSelectEvent: PropTypes.func,
  handleChangeStatusClick: PropTypes.func,
  restricted: PropTypes.bool,
};

DashboardView.defaultProps = {
  events: [],
  Component: ListView,
  handleSelectEvent: () => {},
  handleChangeStatusClick: () => {},
  restricted: false,
};

export default DashboardView;
